import { render, staticRenderFns } from "./ExcelSegment.vue?vue&type=template&id=6a3f172a&scoped=true&"
import script from "./ExcelSegment.vue?vue&type=script&lang=js&"
export * from "./ExcelSegment.vue?vue&type=script&lang=js&"
import style0 from "./ExcelSegment.vue?vue&type=style&index=0&id=6a3f172a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3f172a",
  null
  
)

export default component.exports